export default __webpack_public_path__ + "static/media/invite_link.d6877a46.svg";